var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.84,175H150.68V91.7h16.16Zm-35,0H115.7V124.41h16.16Zm-35,0H80.72V111.18H96.88Zm-35,0H45.74V133.91H61.9Zm69-92.12,21.39-24.79M96.44,75.5l18.43,9.61M60.81,102.33,83.52,80.18M166.3,45.71A9,9,0,1,0,163,58.06,9,9,0,0,0,166.3,45.71ZM131.21,84.46a9,9,0,1,0-3.34,12.35A9,9,0,0,0,131.21,84.46ZM95.69,67a9.05,9.05,0,1,0-3.34,12.35A9.05,9.05,0,0,0,95.69,67ZM60.81,102.33a9,9,0,1,0-3.34,12.35A9,9,0,0,0,60.81,102.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/DATA.bbc088211b98b2dbc87e9837827b5dfa.svg";
export { ForwardRef as ReactComponent };